import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export async function getMetaDataForFilter() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/new-meta-data`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function getAllAssessments(params = {}) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const normalizeNullableQueryValue = (value) => {
    if (value === null || value === undefined || value === "") return "null";
    if (Array.isArray(value)) return value.length ? value.join(",") : "null";
    return String(value);
  };

  const queryEntries = [
    ["limit", String(params.limit ?? 100)],
    ["offset", String(params.offset ?? 0)],
    ["sort_column", String(params.sort_column ?? "created_at")],
    ["sort_direction", String(params.sort_direction ?? "DESC")],
    ["search_term", String(params.search_term ?? "")],
    ["selectedCategories", normalizeNullableQueryValue(params.selectedCategories)],
    ["selectedAuthors", normalizeNullableQueryValue(params.selectedAuthors)],
    ["selectedChapters", normalizeNullableQueryValue(params.selectedChapters)],
    ["selectedGrades", normalizeNullableQueryValue(params.selectedGrades)],
    ["selectedDifficulties", normalizeNullableQueryValue(params.selectedDifficulties)],
    ["selectedLanguages", normalizeNullableQueryValue(params.selectedLanguages)],
    ["selectedTerms", normalizeNullableQueryValue(params.selectedTerms)],
    ["selectedYears", normalizeNullableQueryValue(params.selectedYears)],
    ["selectedsubjects", normalizeNullableQueryValue(params.selectedsubjects)],
    ["selectedStatuses", normalizeNullableQueryValue(params.selectedStatuses)],
    ["selectedExamCategories", normalizeNullableQueryValue(params.selectedExamCategories)],
    ["selectedSources", normalizeNullableQueryValue(params.selectedSources)],
    ["selectedCreators", normalizeNullableQueryValue(params.selectedCreators)],
    ["selectedStartDate", normalizeNullableQueryValue(params.selectedStartDate)],
    ["selectedEndDate", normalizeNullableQueryValue(params.selectedEndDate)],
  ];

  const queryString = queryEntries
    .map(([key, value]) => `${encodeURIComponent(key)}=${value}`)
    .join("&");

  return await fetch(
    `${config.oat_api_url}/assessment_new/getAllAssessments?${queryString}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function getAllAssessmentsForPaperReview(params = {}, userID, employeeType) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const normalizeNullableQueryValue = (value) => {
    if (value === null || value === undefined || value === "") return "null";
    if (Array.isArray(value)) return value.length ? value.join(",") : "null";
    return String(value);
  };

  const queryEntries = [
    ["limit", String(params.limit ?? 100)],
    ["offset", String(params.offset ?? 0)],
    ["sort_column", String(params.sort_column ?? "created_at")],
    ["sort_direction", String(params.sort_direction ?? "DESC")],
    ["search_term", String(params.search_term ?? "")],
    ["selectedCategories", normalizeNullableQueryValue(params.selectedCategories)],
    ["selectedAuthors", normalizeNullableQueryValue(params.selectedAuthors)],
    ["selectedChapters", normalizeNullableQueryValue(params.selectedChapters)],
    ["selectedGrades", normalizeNullableQueryValue(params.selectedGrades)],
    ["selectedDifficulties", normalizeNullableQueryValue(params.selectedDifficulties)],
    ["selectedLanguages", normalizeNullableQueryValue(params.selectedLanguages)],
    ["selectedTerms", normalizeNullableQueryValue(params.selectedTerms)],
    ["selectedYears", normalizeNullableQueryValue(params.selectedYears)],
    ["selectedsubjects", normalizeNullableQueryValue(params.selectedsubjects)],
    ["selectedStatuses", normalizeNullableQueryValue(params.selectedStatuses)],
    ["selectedExamCategories", normalizeNullableQueryValue(params.selectedExamCategories)],
    ["selectedSources", normalizeNullableQueryValue(params.selectedSources)],
    ["selectedCreators", normalizeNullableQueryValue(params.selectedCreators)],
    ["selectedStartDate", normalizeNullableQueryValue(params.selectedStartDate)],
    ["selectedEndDate", normalizeNullableQueryValue(params.selectedEndDate)],
    ...(userID ? [["user_id", String(userID)]] : []),
    ...(employeeType ? [["employeeType", String(employeeType)]] : []),
  ];

  const queryString = queryEntries
    .map(([key, value]) => `${encodeURIComponent(key)}=${value}`)
    .join("&");

  return await fetch(
    `${config.oat_api_url}/assessment_new/getAllAssessmentsForPaperReview?${queryString}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function getMasterAssessmentsWithFilters(params) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const queryEntries = [
    ["selectedGrades", params.selectedGrades ? params.selectedGrades.join(",") : "null"],
    ["selectedLanguages", params.selectedLanguages ? params.selectedLanguages.join(",") : "null"],
    ["selectedsubjects", params.selectedsubjects ? params.selectedsubjects.join(",") : "null"],
  ];

  const queryString = queryEntries
    .map(([key, value]) => `${encodeURIComponent(key)}=${value}`)
    .join("&");

  return await fetch(
    `${config.oat_api_url}/assessment_new/getMasterAssessmentsWithFilters?${queryString}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function createAssessment(payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessments/add/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function updateAssessment(assessmentId, payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessments/edit/${assessmentId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function deleteAssessment(assessmentId) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/delete/${assessmentId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function getAllQuestionsForAddQuestionInSetupWithFilter({
    params = {},
    assessmentId,
  }) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const normalizeNullableQueryValue = (value) => {
    if (value === null || value === undefined || value === "") return "null";
    if (Array.isArray(value)) return value.length ? value.join(",") : "null";
    return String(value);
  };

  const queryEntries = [
    ["limit", String(params.limit ?? 20)],
    ["offset", String(params.offset ?? 0)],
    ["assessment_id", normalizeNullableQueryValue(assessmentId)],
    ["search_term", String(params.search_term ?? "")],
    ["sort_column", String(params.sort_column ?? "created_at")],
    ["sort_direction", String(params.sort_direction ?? "DESC")],
    ["selectType", normalizeNullableQueryValue(params.selectedTypes ?? params.selectType)],
    ["selectedCategories", normalizeNullableQueryValue(params.selectedCategories)],
    ["selectedDifficulties", normalizeNullableQueryValue(params.selectedDifficulties)],
    ["selectedAuthors", normalizeNullableQueryValue(params.selectedAuthors)],
    ["selectedChapters", normalizeNullableQueryValue(params.selectedChapters)],
    ["selectedGrades", normalizeNullableQueryValue(params.selectedGrades)],
    ["selectedCreators", normalizeNullableQueryValue(params.selectedCreators)],
    ["selectedLanguages", normalizeNullableQueryValue(params.selectedLanguages)],
    ["selectedsubjects", normalizeNullableQueryValue(params.selectedsubjects)],
    ["selectedSources", normalizeNullableQueryValue(params.selectedSources)],
    ["selectedYears", normalizeNullableQueryValue(params.selectedYears)],
    ["selectedTerms", normalizeNullableQueryValue(params.selectedTerms)],
    ["selectedStartDate", normalizeNullableQueryValue(params.selectedStartDate)],
    ["selectedEndDate", normalizeNullableQueryValue(params.selectedEndDate)],
  ];

  const queryString = queryEntries
    .map(([key, value]) => `${encodeURIComponent(key)}=${value}`)
    .join("&");

  return await fetch(
    `${config.oat_api_url}/assessment_new/getAllQuestionsForAddQuestionInSetupWithFilter?${queryString}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function getAllQuestionsForAddedQuestionInSetupAndQuestionPool(
  assessmentId
) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/getAllQuestionsForAddedQuestionInSetupAndQuestionPool?assessment_id=${assessmentId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function addQuestionsToAssessmentSetup(questionsData) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(questionsData),
  };
  return await fetch(
    `${config.oat_api_url}/assessment/questions/addAll/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}


export async function addAssessmentPart(payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/add-assessment-part`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function addAssessmentSection(payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/add-assessment-part-section`,
    requestOptions
  ).then(APIHandler.handleResponse);
}


export async function updateQuestionSection(payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessment/questions/update-section/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}


export async function saveAssessmentQuestions(payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/saveUpdates/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function finalizeAssessment(payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessments/finalizeAssessment/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function finishPaperReview(assessmentId, reviewerId, asmntReviewId, assessmentState) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({ assessment_state: assessmentState }),
  };

  return await fetch(
    `${config.oat_api_url}/assessments/finish_review_by_id/${assessmentId}/${reviewerId}/${asmntReviewId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function reset_assessment_setup(assessment_id) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/reset-assessment-setup/${assessment_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
  
}

export async function remove_assessment_question_from_setup(
  assessmentId,
  assessorId,
  questionIds
) {
  const deleteQuestions = (Array.isArray(questionIds) ? questionIds : [questionIds])
    .map(Number)
    .filter(Number.isFinite);

  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({
      assessment_id: Number(assessmentId),
      assessor_id: assessorId,
      delete_questions: deleteQuestions,
    }),
  };
  return await fetch(
    `${config.oat_api_url}/assessment/questions/remove/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function deleteAssessmentSection(assessmentId, sectionId) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({
      assessment_id: Number(assessmentId),
      section_id: Number(sectionId),
    }),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/assessment-section/delete`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function deleteAssessmentPart(assessmentId, partId) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({
      assessment_id: Number(assessmentId),
      part_id: Number(partId),
    }),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/assessment-part/delete`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function editAssessmentPart(partId, payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/assessment-part/edit/${partId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function editAssessmentSection(sectionId, payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/assessment-section/edit/${sectionId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function  get_assessment_details_with_parts_sections(assessmentId) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/get-assessment-details-with-parts-sections/${assessmentId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function updateQuestionById(assessmentId, questionId,userId, payload) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
     body: JSON.stringify(payload),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/update-question-by-id/${questionId}/${userId}/${assessmentId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function assign_proofreader(assessment_id, payload) {
   const userId = sessionStorage.getItem('manage_user_id');
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({
      selected_operator: payload.selected_operator,
      selected_operation: payload.selected_operation,
    }),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/assign_operator_to_assessment/${assessment_id}/${userId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}


export async function assign_reviewer(assessment_id, payload) {
   const userId = sessionStorage.getItem('manage_user_id');
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({
      selected_reviewer: payload.selected_reviewer,
    }),
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/assign_reviewer_to_assessment/${assessment_id}/${userId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}


export async function getTeacherAssignedAssessments( params = {},teacherId) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const normalizeNullableQueryValue = (value) => {
    if (value === null || value === undefined || value === "") return "null";
    if (Array.isArray(value)) return value.length ? value.join(",") : "null";
    return String(value);
  };

  const queryEntries = [
    ["limit", String(params.limit ?? 100)],
    ["offset", String(params.offset ?? 0)],
    ["sort_column", String(params.sort_column ?? "created_at")],
    ["sort_direction", String(params.sort_direction ?? "DESC")],
    ["search_term", String(params.search_term ?? "")],
    ["selectedCategories", normalizeNullableQueryValue(params.selectedCategories)],
    ["selectedAuthors", normalizeNullableQueryValue(params.selectedAuthors)],
    ["selectedChapters", normalizeNullableQueryValue(params.selectedChapters)],
    ["selectedGrades", normalizeNullableQueryValue(params.selectedGrades)],
    ["selectedDifficulties", normalizeNullableQueryValue(params.selectedDifficulties)],
    ["selectedLanguages", normalizeNullableQueryValue(params.selectedLanguages)],
    ["selectedTerms", normalizeNullableQueryValue(params.selectedTerms)],
    ["selectedYears", normalizeNullableQueryValue(params.selectedYears)],
    ["selectedsubjects", normalizeNullableQueryValue(params.selectedsubjects)],
    ["selectedStatuses", normalizeNullableQueryValue(params.selectedStatuses)],
    ["selectedExamCategories", normalizeNullableQueryValue(params.selectedExamCategories)],
    ["selectedSources", normalizeNullableQueryValue(params.selectedSources)],
    ["selectedCreators", normalizeNullableQueryValue(params.selectedCreators)],
    ["selectedStartDate", normalizeNullableQueryValue(params.selectedStartDate)],
    ["selectedEndDate", normalizeNullableQueryValue(params.selectedEndDate)],
  ];

  const queryString = queryEntries
    .map(([key, value]) => `${encodeURIComponent(key)}=${value}`)
    .join("&");

  return await fetch(
    `${config.oat_api_url}/assessment_new/getTeacherAssignedAssessments/${teacherId}?${queryString}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function getDEOPAssignedAssessments(params = {}, employeeId) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const normalizeNullableQueryValue = (value) => {
    if (value === null || value === undefined || value === "") return "null";
    if (Array.isArray(value)) return value.length ? value.join(",") : "null";
    return String(value);
  };

  const queryEntries = [
    ["limit", String(params.limit ?? 100)],
    ["offset", String(params.offset ?? 0)],
    ["sort_column", String(params.sort_column ?? "created_at")],
    ["sort_direction", String(params.sort_direction ?? "DESC")],
    ["search_term", String(params.search_term ?? "")],
    ["selectedCategories", normalizeNullableQueryValue(params.selectedCategories)],
    ["selectedAuthors", normalizeNullableQueryValue(params.selectedAuthors)],
    ["selectedChapters", normalizeNullableQueryValue(params.selectedChapters)],
    ["selectedGrades", normalizeNullableQueryValue(params.selectedGrades)],
    ["selectedDifficulties", normalizeNullableQueryValue(params.selectedDifficulties)],
    ["selectedLanguages", normalizeNullableQueryValue(params.selectedLanguages)],
    ["selectedTerms", normalizeNullableQueryValue(params.selectedTerms)],
    ["selectedYears", normalizeNullableQueryValue(params.selectedYears)],
    ["selectedsubjects", normalizeNullableQueryValue(params.selectedsubjects)],
    ["selectedStatuses", normalizeNullableQueryValue(params.selectedStatuses)],
    ["selectedExamCategories", normalizeNullableQueryValue(params.selectedExamCategories)],
    ["selectedSources", normalizeNullableQueryValue(params.selectedSources)],
    ["selectedCreators", normalizeNullableQueryValue(params.selectedCreators)],
    ["selectedStartDate", normalizeNullableQueryValue(params.selectedStartDate)],
    ["selectedEndDate", normalizeNullableQueryValue(params.selectedEndDate)],
  ];

  const queryString = queryEntries
    .map(([key, value]) => `${encodeURIComponent(key)}=${value}`)
    .join("&");

  return await fetch(
    `${config.oat_api_url}/assessment_new/getEmployeeAssignedAssessments/${employeeId}?${queryString}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function MarkAsReviewed(assessment_id, payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/mark_as_reviewd/${assessment_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
};

export async function addComment(assessment_id, payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/add_sub_review/${assessment_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
};

export async function addSubOperationComment(assessment_id, payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/add_sub_operation_comment/${assessment_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
};

export async function finishProofreading(assessmentId,employee_id,asmnt_operation_id, payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/finish_operation_by_id/${assessmentId}/${employee_id}/${asmnt_operation_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);

}

//-------------------------------------------------------------------------------------

export async function set_review_for_paper(
  assessmentId,
  reviewerId,
  asmntReviewId,
  payload = {}
) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/set_review_by_id/${assessmentId}/${reviewerId}/${asmntReviewId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function set_paper_to_publish(assessmentId,asmntReviewId,userId, payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/set_paper_to_publish/${assessmentId}/${asmntReviewId}/${userId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function set_for_review_by_completed(assessmentId,asmntReviewId, reviewerId, payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/set_for_review_by_completed/${assessmentId}/${reviewerId}/${asmntReviewId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function finalize_paper(assessmentId,asmntReviewId, reviewerId, payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/finalize_paper_by_id/${assessmentId}/${asmntReviewId}/${reviewerId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
} 

export async function updateAssessmentStatus(assessmentId, payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessments/update_assessment_status/${assessmentId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}


//-------------------------------------------------------------------------------------

export async function resetAssigner(assessment_id,payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload)
  };
  return await fetch(
    `${config.oat_api_url}/assessment_new/v2/reset_assessment_assigner/${assessment_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

export async function reset_assessment_review(assessment_id) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({}),
  };
  return await fetch(
    `${config.oat_api_url}/assessments/reset_assessment_review/${assessment_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}


